import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { RejectionReasonDropDown } from '../../_models/aajeevika.model';
import { BankDetails, BlockMasterList, DistrictMasterList, PanchayatMasterList, StatesMasterList } from '../../_models/geo.model';
import { SectorsResponse } from '../../_models/lakhpati-didi.model';
import { CDN_URL } from '../../_urls/cdn.urls';
import { HttpService } from '../_http/http.service';

@Injectable({
    providedIn: 'root'
})
export class CdnService {
    CDN_URL = environment.cdnUrl;
    CDN_URL_KEYCLOCK = environment.keyclockCdnUrl;

    constructor (private httpService: HttpService) { }

    /**
   * get States List
   * @returns observable of response
   */
    getStatesList () {
        const url = `${this.CDN_URL}${CDN_URL.STATE}`;
        return this.httpService.getRecords<StatesMasterList[]>(url);
    }

    /**
   * get Districts List
   * @param stateId
   * @returns observable of response
   */
    getDistrictsList (stateId: string | number) {
        stateId = `${stateId}`.padStart(2, '0');
        const url = `${this.CDN_URL}state/${stateId}.json`;
        return this.httpService.getRecords<DistrictMasterList[]>(url);
    }

    /**
   * get block List
   * @param stateId
   * @param districtId
   * @returns observable of response
   */
    getblockList (stateId: string | number, districtId: string | number) {
        stateId = `${stateId}`.padStart(2, '0');
        const url = `${this.CDN_URL}state/${stateId}/district/${districtId}.json`;
        return this.httpService.getRecords<BlockMasterList[]>(url);
    }

    /**
   * get panchayat List
   * @param stateId
   * @param districtId
   * @param blockId
   * @returns observable of response
   */
    getpanchayatList (
        stateId: string | number,
        districtId: string | number,
        blockId: string | number
    ) {
        stateId = `${stateId}`.padStart(2, '0');
        const url = `${this.CDN_URL}state/${stateId}/district/${districtId}/block/${blockId}.json`;
        return this.httpService.getRecords<PanchayatMasterList[]>(url);
    }

    /**
   * get village List
   * @param stateId
   * @param districtId
   * @param blockId
   * @param panchayatId
   * @returns observable of response
   */
    getvillageList (
        stateId: string | number,
        districtId: string | number,
        blockId: string | number,
        panchayatId: string | number
    ) {
        stateId = `${stateId}`.padStart(2, '0');
        const url = `${this.CDN_URL}state/${stateId}/district/${districtId}/block/${blockId}/panchayat/${panchayatId}.json`;
        return this.httpService.getRecords(url);
    }

    getVillageListsByBlockId (
        stateId: any,
        districtId: any,
        blockId: any
    ): Observable<any[]> {

        return this.getpanchayatList(stateId, districtId, blockId).pipe(
            map((response: any) => {
                const panchayatList = response as PanchayatMasterList[];
                const villageLists = panchayatList.flatMap((item: any) =>
                    (item.villagelist || []).map((village: any) => ({
                        ...village,
                        village_name_en: village.villageNameEnglish,
                        village_id: village.villageId,
                        panchayat_name: item.panchayat_name_en || item.panchayat_name
                    }))
                );
                return villageLists;
            })
        );
    }


    getBankList (stateId: string, districtId: string) {
    // const stateIdLength = +stateId < 10 ? `0${stateId}` : stateId;
        const url = `${this.CDN_URL}bank/state/${stateId}/district/${districtId}.json`;
        return this.httpService.getRecords(url);
    }

    getBranchList (stateId: string, districtId: string) {
    // const stateIdLength = +stateId < 10 ? `0${stateId}` : stateId;
        const url = `${this.CDN_URL}branch/state/${stateId}/district/${districtId}.json`;
        return this.httpService.getRecords(url);
    }

    getGeoLocationMaping () {
        const url = `${this.CDN_URL_KEYCLOCK}geo-map.json`;
        return this.httpService.getRecords(url);
    }

    getClientIdsMaping () {
        const url = `${this.CDN_URL_KEYCLOCK}client-map.json?x=x`;
        return this.httpService.getRecords(url);
    }

    /**
    /**
   * get master Data
   * @returns observable of response
   */
    getLokosMasterData<T> () {
        const url = `${this.CDN_URL}lang/en.json`;
        return this.httpService.getRecords<T>(url);
    }

    getFundTypeMasterList () {
        const url = `${this.CDN_URL}allfundtype.json`;
        return this.httpService.getRecords(url);
    }

    getBanks (stateId: string | number, districtId: string | number): Observable<BankDetails[]> {
        const paddedStateId = `${stateId}`.padStart(2, '0');
        const url = `${environment.cdnUrl}bank/state/${paddedStateId}/district/${districtId}.json`;

        return this.httpService.getRecords(url);
    }
    getBranch (stateId: string | number, districtId: string | number): Observable<any> {
        const paddedStateId = `${stateId}`.padStart(2, '0');
        const url = `${environment.cdnUrl}branch/state/${paddedStateId}/district/${districtId}.json`;

        return this.httpService.getRecords(url);
    }

    // Get Funding Agency Master List
    getFundingAgencyMasterList (): Observable<any> {
        const url = `${this.CDN_URL}funding-agency.json`;
        return this.httpService.getRecords(url);
    }

    //get all village
    getVillageLists (stateId: any, districtId: any, blockId: any, panchayatId: any) {
        const paddedStateId = `${stateId}`.padStart(2, '0');
        const url = `${this.CDN_URL}state/${paddedStateId}/district/${districtId}/block/${blockId}/panchayat/${panchayatId}.json`;

        return this.httpService.getRecords(url);
    }

    // Get Lakhpati Didi sectors
    getSectors (): Observable<SectorsResponse> {
        const url = `${this.CDN_URL}sectors.json`;
        return this.httpService.getRecords<SectorsResponse>(url);
    }

    // Get reject reason dropdown options
    getRejectDropdownOptions (): Observable<RejectionReasonDropDown[]> {
        const url = `${this.CDN_URL}reject-reason.json`;
        return this.httpService.getRecords<RejectionReasonDropDown[]>(url);
    }
}
